var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { tagsApi } from 'apis/tags';
import { analytics } from 'app/utils/segment';
import { getCreateItemContext } from 'components/categorizedList';
import { TagContent } from 'components/tags/tagContent';
import { isResponseWithData } from 'utils/apis/axios';
/** Represents the tag create item content. */
export const TagCreateItemContent = () => {
    const { searchTerm: name, setCreate } = useContext(getCreateItemContext());
    const [color, setColor] = useState(null);
    const [createTag] = tagsApi.useCreateTagMutation();
    // Handles setting the tag create function.
    useEffect(() => {
        setCreate(() => () => __awaiter(void 0, void 0, void 0, function* () {
            const response = yield createTag({ name, color: color !== null && color !== void 0 ? color : undefined });
            if (isResponseWithData(response)) {
                analytics.tagSelectCreateNewTagClicked({
                    tagName: name,
                    component: 'CategorizedTagsList',
                });
                return response.data.data;
            }
        }));
    }, [name, color, createTag, setCreate]);
    return _jsx(TagContent, { tag: { name, color: null }, onColorChange: setColor });
};
